import { getModule } from "vuex-module-decorators";
import store from '..';
import eventBroadcaster from '@/service/eventBroadcaster';
import SessionsModule from "../modules/Sessions";
import Vue from 'vue';

const sessionsModule = getModule(SessionsModule, store);

eventBroadcaster.registerListener(
    'raws.event.session.orderPlaced',
    (payload: { sessionId: string; clientName: string; photoIds: string[]; requiresFinalization: boolean; finalizationMode: boolean }) => {
        sessionsModule.newOrderAdded(payload);
        (new Vue() as any).$vToastify.info({
            title: 'Nowe zamówienie',
            body: `${payload.clientName} złożył zamówienie.`,
        });
    }
);
